import { defu } from 'defu'
import type { App } from 'vue'
import { defaults } from '@R/constants/toastOptions'

import NotifierContainer from '@R/components/ToastAlerts/ToastContainer.vue'
import type { NotifierOptions } from '@R/types/toastTypes'

export { useNotifier } from '@R/composables/useNotifier'

export default defineNuxtPlugin((nuxtApp) => {
    const app: App = nuxtApp.vueApp
    const options: Partial<NotifierOptions> = {}

    app.provide('notifier', defu(options, defaults))
    app.component('VNotifierContainer', NotifierContainer)
})